(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sync-buy-box"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sync-buy-box')) {
    customElements.define(
      'sync-buy-box',
      class extends HTMLElement {
        connectedCallback() {
          if (this.ready) {
            document.addEventListener(
              'visibilitychange',
              this.onVisibility
            );
            this.updateDate();
            return;
          }

          this.ready = true;
          this.radios = Array.from(
            this.querySelectorAll('.sbb__radio')
          );
          this.refill = this.querySelector('[data-refill]');
          this.atc = this.querySelector('[data-atc]');

          this.addEventListener('change', () => this.update());

          this.atc.addEventListener('click', () => {
            const option = this.radios.find(r => r.checked);

            const detail = {
              offer: option.value,
              title: option.dataset.title,
              quantity: Number(option.value),
              amount: Number(
                this.refill.checked
                  ? option.dataset.sub
                  : option.dataset.once
              ),
              currency: 'ZAR',
              recurring: this.refill.checked,
              intervalDays: Number(option.dataset.days)
            };

            this.dispatchEvent(
              new CustomEvent('sync:buy-box-select', {
                bubbles: true,
                detail
              })
            );

            this.querySelector('[data-status]').textContent =
              `${detail.title} selected — ${this.money(detail.amount)}` +
              (
                detail.recurring
                  ? ' with automatic refills.'
                  : ' as a one-time purchase.'
              );
          });

          this.update();
          this.updateDate();

          this.onVisibility = () => {
            if (!document.hidden) this.updateDate();
          };

          document.addEventListener(
            'visibilitychange',
            this.onVisibility
          );
        }

        disconnectedCallback() {
          document.removeEventListener(
            'visibilitychange',
            this.onVisibility
          );
        }

        money(cents) {
          return 'R' + (cents / 100).toLocaleString('en-ZA', {
            maximumFractionDigits: 2,
            minimumFractionDigits: cents % 100 ? 2 : 0
          });
        }

        update() {
          const recurring = this.refill.checked;

          this.radios.forEach(radio => {
            const card = radio.nextElementSibling;
            const price = Number(
              recurring
                ? radio.dataset.sub
                : radio.dataset.once
            );
            const compare = Number(radio.dataset.once);

            card.querySelector('[data-price]').textContent =
              price > 0 ? this.money(price) : '—';

            const strike = card.querySelector('[data-compare]');
            strike.textContent = this.money(compare);
            strike.hidden =
              !recurring || compare <= price || price <= 0;
          });

          this.querySelectorAll('[data-sub-benefit]')
            .forEach(el => {
              el.hidden = !recurring;
            });

          this.querySelector('[data-refill-copy]').hidden =
            !recurring;

          const selected = this.radios.find(r => r.checked);
          const price = Number(
            recurring
              ? selected.dataset.sub
              : selected.dataset.once
          );

          this.querySelector('[data-total]').textContent =
            price > 0 ? this.money(price) : '—';

          this.atc.disabled = price <= 0;

          let terms = '';

          if (price > 0 && recurring) {
            terms =
              `${this.money(price)} charged every ` +
              `${selected.dataset.days} days. ` +
              (
                selected.value === '1'
                  ? 'Delivery charged separately.'
                  : 'First order ships free; later shipping calculated at checkout.'
              );
          } else if (price > 0) {
            terms =
              `${this.money(price)} once. No automatic refills. ` +
              'Shipping calculated at checkout.';
          }

          this.querySelector('[data-terms]').textContent = terms;
          this.querySelector('[data-status]').textContent = '';
        }

        updateDate() {
          const parts = new Intl.DateTimeFormat('en-GB', {
            timeZone: 'Africa/Johannesburg',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          }).formatToParts(new Date());

          const value = type =>
            Number(parts.find(p => p.type === type).value);

          const date = new Date(
            Date.UTC(
              value('year'),
              value('month') - 1,
              value('day')
            )
          );

          let left = Math.max(
            2,
            Math.min(4, Number(this.dataset.days) || 3)
          );

          while (left > 0) {
            date.setUTCDate(date.getUTCDate() + 1);

            if (
              date.getUTCDay() !== 0 &&
              date.getUTCDay() !== 6
            ) {
              left--;
            }
          }

          const time = this.querySelector('[data-ship-date]');
          time.dateTime = date.toISOString().slice(0, 10);
          time.textContent = new Intl.DateTimeFormat('en-ZA', {
            weekday: 'short',
            day: 'numeric',
            month: 'short',
            timeZone: 'UTC'
          }).format(date);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
